export default __webpack_public_path__ + "static/media/moi.74f778f8.svg";